/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackNodeListRsp } from '../models/unistack-node-list-rsp';
import { UnistackNodeCreateRsp } from '../models/unistack-node-create-rsp';
import { UnistackNodeCreateReq } from '../models/unistack-node-create-req';
import { UnistackNodeLookupRsp } from '../models/unistack-node-lookup-rsp';
import { UnistackNodeUpdateRsp } from '../models/unistack-node-update-rsp';
import { UnistackNodeUpdateReq } from '../models/unistack-node-update-req';
import { UnistackNodeDeleteRsp } from '../models/unistack-node-delete-rsp';
import { RuntimeStreamError } from '../models/runtime-stream-error';
import { UnistackChunk } from '../models/unistack-chunk';
@Injectable({
  providedIn: 'root',
})
class NodeServiceService extends __BaseService {
  static readonly NodeListPath = '/api/unistack/v0/nodes';
  static readonly NodeCreatePath = '/api/unistack/v0/nodes';
  static readonly NodeSearchPath = '/api/unistack/v0/nodes/search';
  static readonly NodeLookupPath = '/api/unistack/v0/nodes/{uuid}';
  static readonly NodeUpdatePath = '/api/unistack/v0/nodes/{uuid}';
  static readonly NodeDeletePath = '/api/unistack/v0/nodes/{uuid}';
  static readonly NodeConsolePath = '/api/unistack/v0/nodes/{uuid}/console';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `NodeServiceService.NodeListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  NodeListResponse(params: NodeServiceService.NodeListParams): __Observable<__StrictHttpResponse<UnistackNodeListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    if (params.filter != null) __params = __params.set('filter', params.filter.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/nodes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeListRsp>;
      })
    );
  }
  /**
   * @param params The `NodeServiceService.NodeListParams` containing the following parameters:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `filter`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  NodeList(params: NodeServiceService.NodeListParams): __Observable<UnistackNodeListRsp> {
    return this.NodeListResponse(params).pipe(
      __map(_r => _r.body as UnistackNodeListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  NodeCreateResponse(body: UnistackNodeCreateReq): __Observable<__StrictHttpResponse<UnistackNodeCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/nodes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  NodeCreate(body: UnistackNodeCreateReq): __Observable<UnistackNodeCreateRsp> {
    return this.NodeCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackNodeCreateRsp)
    );
  }

  /**
   * @param params The `NodeServiceService.NodeSearchParams` containing the following parameters:
   *
   * - `zone`:
   *
   * - `status`:
   *
   * - `name`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * @return A successful response.
   */
  NodeSearchResponse(params: NodeServiceService.NodeSearchParams): __Observable<__StrictHttpResponse<UnistackNodeListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.zone != null) __params = __params.set('zone', params.zone.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.name != null) __params = __params.set('name', params.name.toString());
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/nodes/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeListRsp>;
      })
    );
  }
  /**
   * @param params The `NodeServiceService.NodeSearchParams` containing the following parameters:
   *
   * - `zone`:
   *
   * - `status`:
   *
   * - `name`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * @return A successful response.
   */
  NodeSearch(params: NodeServiceService.NodeSearchParams): __Observable<UnistackNodeListRsp> {
    return this.NodeSearchResponse(params).pipe(
      __map(_r => _r.body as UnistackNodeListRsp)
    );
  }

  /**
   * @param params The `NodeServiceService.NodeLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  NodeLookupResponse(params: NodeServiceService.NodeLookupParams): __Observable<__StrictHttpResponse<UnistackNodeLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/nodes/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeLookupRsp>;
      })
    );
  }
  /**
   * @param params The `NodeServiceService.NodeLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  NodeLookup(params: NodeServiceService.NodeLookupParams): __Observable<UnistackNodeLookupRsp> {
    return this.NodeLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackNodeLookupRsp)
    );
  }

  /**
   * @param params The `NodeServiceService.NodeUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  NodeUpdateResponse(params: NodeServiceService.NodeUpdateParams): __Observable<__StrictHttpResponse<UnistackNodeUpdateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/unistack/v0/nodes/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeUpdateRsp>;
      })
    );
  }
  /**
   * @param params The `NodeServiceService.NodeUpdateParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  NodeUpdate(params: NodeServiceService.NodeUpdateParams): __Observable<UnistackNodeUpdateRsp> {
    return this.NodeUpdateResponse(params).pipe(
      __map(_r => _r.body as UnistackNodeUpdateRsp)
    );
  }

  /**
   * @param uuid undefined
   * @return A successful response.
   */
  NodeDeleteResponse(uuid: string): __Observable<__StrictHttpResponse<UnistackNodeDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/nodes/${uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNodeDeleteRsp>;
      })
    );
  }
  /**
   * @param uuid undefined
   * @return A successful response.
   */
  NodeDelete(uuid: string): __Observable<UnistackNodeDeleteRsp> {
    return this.NodeDeleteResponse(uuid).pipe(
      __map(_r => _r.body as UnistackNodeDeleteRsp)
    );
  }

  /**
   * @param params The `NodeServiceService.NodeConsoleParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  NodeConsoleResponse(params: NodeServiceService.NodeConsoleParams): __Observable<__StrictHttpResponse<{error?: RuntimeStreamError, result?: UnistackChunk}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.type != null) __params = __params.set('type', params.type.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/nodes/${params.uuid}/console`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{error?: RuntimeStreamError, result?: UnistackChunk}>;
      })
    );
  }
  /**
   * @param params The `NodeServiceService.NodeConsoleParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `type`:
   *
   * @return A successful response.(streaming responses)
   */
  NodeConsole(params: NodeServiceService.NodeConsoleParams): __Observable<{error?: RuntimeStreamError, result?: UnistackChunk}> {
    return this.NodeConsoleResponse(params).pipe(
      __map(_r => _r.body as {error?: RuntimeStreamError, result?: UnistackChunk})
    );
  }
}

module NodeServiceService {

  /**
   * Parameters for NodeList
   */
  export interface NodeListParams {
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    filter?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_name' | 'field_status' | 'field_enabled' | 'field_zone'>;
  }

  /**
   * Parameters for NodeSearch
   */
  export interface NodeSearchParams {
    zone?: string;
    status?: 'NODE_STATUS_UNKNOWN' | 'NODE_STATUS_ENABLED' | 'NODE_STATUS_DISABLED' | 'NODE_STATUS_BLOCKED' | 'NODE_STATUS_DELETED';
    name?: string;
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
  }

  /**
   * Parameters for NodeLookup
   */
  export interface NodeLookupParams {
    uuid: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_name' | 'field_status' | 'field_enabled' | 'field_zone'>;
  }

  /**
   * Parameters for NodeUpdate
   */
  export interface NodeUpdateParams {
    uuid: string;
    body: UnistackNodeUpdateReq;
  }

  /**
   * Parameters for NodeConsole
   */
  export interface NodeConsoleParams {
    uuid: string;
    type?: 'invalid' | 'vnc' | 'rfb' | 'spice' | 'term';
  }
}

export { NodeServiceService }
